export default __webpack_public_path__ + "static/media/Back1.a1a7f7d8.jpg";